import React from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { Window, WindowContent, WindowHeader, Button, Cutout } from "react95";
import at from "lodash/at";
import error from "../error.png";
import { clearError } from "../reducers/error";

const WindowWrapper = styled.div`
    width: 560px;
    position: absolute;
    z-index: 1;
    top: 25vh;

    @media (max-width: 768px) {
        top: 10vh;
        width: 100%;
    }
`;

const Container = styled.div`
    display: flex;
    height: 125px;
    margin-bottom: 15px;
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30%;
`;

const ImageContainer = styled.div`
    flex: 1 1 0px;
    margin-right: 15px;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 15px;
    margin-bottom: 30px;

    @media (max-width: 768px) {
        margin-bottom: 0px;
    }
`;

const ErrorWindow = () => {
    const dispatch = useDispatch();
    const [currentError, isDismissed] = useSelector((state) =>
        at(state, "error.message", "error.dismissed")
    );

    return (
        <>
            {!isDismissed && (
                <WindowWrapper>
                    <Window>
                        <WindowHeader
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between"
                            }}
                        >
                            <span>beet_harvester.exe</span>
                            <Button
                                style={{ marginRight: "-6px", marginTop: "1px" }}
                                size="sm"
                                square
                            >
                                <span style={{ fontWeight: "bold", transform: "translateY(-1px)" }}>
                                    x
                                </span>
                            </Button>
                        </WindowHeader>
                        <WindowContent>
                            <Container>
                                <ImageContainer>
                                    <img width="42px" src={error} alt="Logo" />
                                </ImageContainer>
                                <TextContainer>
                                    <p>
                                        This program has performed an illegal operation, please see
                                        the error output below.
                                    </p>

                                    <p>
                                        If the problem persists, please raise an issue&nbsp;
                                        <a
                                            style={{
                                                textDecoration: "underline",
                                                color: "#0504fb"
                                            }}
                                            href="fakinell.com"
                                        >
                                            here
                                        </a>
                                        .
                                    </p>
                                </TextContainer>
                                <ButtonContainer>
                                    <Button
                                        fullWidth
                                        size="md"
                                        onClick={() => dispatch(clearError())}
                                    >
                                        Close
                                    </Button>
                                    <Button disabled fullWidth size="md">
                                        Details &gt;&gt;
                                    </Button>
                                </ButtonContainer>
                            </Container>
                            <Cutout style={{ height: "150px" }}>
                                <pre
                                    style={{
                                        marginTop: "5px",
                                        marginLeft: "5px",
                                        overflowY: "scroll"
                                    }}
                                >
                                    {currentError}
                                </pre>
                            </Cutout>
                        </WindowContent>
                    </Window>
                </WindowWrapper>
            )}
        </>
    );
};

export default ErrorWindow;
